/* eslint-disable */
import React, {useEffect, useState} from 'react'
import "./riwayatTransaksi.style.css";
import Navbar from '../../component/Navbar';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons';
import {numberWithCommas, saveState} from '../../_helpers';
import {paymentServices} from '../../_services';
import moment from 'moment'
import Loading from "../../component/Loading"
import Layout from "../../component/Layout"
import {loadState} from "../../_helpers/utils"
import {useNavigate} from "react-router-dom";

const RiwayatTransaksi = () => {
    let navigate = useNavigate();
    const [transactionHistory, setTransactionHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    let query = new Map(window.location.href.substring(1).split("?")[1].split("&").map(el => el.split("=")))
    useEffect(() => {
        let startDate = moment().format("DD/MM/YYYY")
        let endDate = moment().subtract(7, 'days').format("DD/MM/YYYY")
        paymentServices.historyPayment('condition=-1&keywords&startdate=' + endDate + '&enddate=' + startDate + '&createby=' + query.get('memberId') + '&status=-1&fromtemplate=true').then(res => {
            setTransactionHistory(res.sort(((a, b) => {
                a = new moment(a.transDate);
                b = new moment(b.transDate);
                return a > b ? -1 : 1; // ascending order
            })));
            setLoading(false)
        })
    }, [])

    const detailTransaction = (e) => {
        navigate("/detail-transaction?id=" + e.transNo);
        saveState('detail-transaction', e)
    }

    return (
        <Layout>
            <Navbar title={'Riwayat Transaksi'}/>
            <div className="container history-trx py-2">
                <div>
                {transactionHistory.length > 0 ? transactionHistory.map((e, v) => {
                    return (
                        <>
                        <div className="columns is-mobile is-vcentered m-0"
                             onClick={() => detailTransaction(e)} key={v}>
                            <div className="column is-11">
                                <p className="font-medium has-text-black">{e.locName}</p>
                                <p className="font-small has-text-grey-light">{moment(e.transDate).format("DD MMMM YYYY HH:mm")}</p>
                                <p className="text-bold font-medium">Rp. {numberWithCommas(Math.round(e.totalAmt))}</p>
                            </div>
                            <div className="column is-centered">
                                <FontAwesomeIcon className="font-medium has-text-black" icon={faChevronRight}/>
                            </div>
                        </div>
                        <hr className="m-0"/>
                        </>
                    )
                }) : loading ? <Loading/> : <p className="has-text-centered pt-3">Belum ada transaksi</p>}
                </div>
                <button onClick={() => navigate(`/home?cardNumber=${loadState('cardNumber')}&sessionId=${loadState('sessionId')}&memberId=${loadState('memberId')}&memberName=${loadState('memberName')}&memberType=${loadState('memberType')}&memberGroup=${loadState('memberGroup')}&tableNo=${loadState('tableNo')}`)} className="btn-history-trx">PESAN KEMBALI</button>
            </div>
        </Layout>
    )
}

export default RiwayatTransaksi
